export const enabledField = {
  methods: {
    enabledField (variable, params) {
      if (!params) this[variable] = !params
    }
  }
}
